var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "20",
        "height": "20",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('rect', {
      attrs: {
        "fill": "#FE943D",
        "width": "20",
        "height": "20",
        "rx": "6"
      }
    }), _c('path', {
      attrs: {
        "d": "M15.365 6.598l-4.76-2.45a1.355 1.355 0 00-1.23 0l-4.76 2.45C4.231 6.795 4 7.155 4 7.55v4.902c0 .394.23.754.615.95l4.77 2.451c.384.197.846.197 1.23 0l4.77-2.45c.384-.197.615-.557.615-.951V7.549a1.131 1.131 0 00-.635-.95zM13.577 8.74l-3.27 1.646v3.316c-.009.17-.047.3-.21.334a.474.474 0 01-.241.06h-.039a.492.492 0 01-.326-.12.39.39 0 01-.135-.292v-3.393c0-.025 0-.051.01-.077L6.441 8.74c-.22-.11-.346-.36-.22-.556a.455.455 0 01.595-.155L10 9.674l3.192-1.645a.44.44 0 01.587.155c.125.188.02.445-.202.556z",
        "fill": "#FFF",
        "fill-rule": "nonzero"
      }
    })])]));
  }
};